/* global api */
const state = {
  forms: [],
  vacForms: [],
  retryLimit: 4,
  submissionProgress: 0,
  submissionComplete: false,
  submissionSuccessful: false,
  currentNumberBeingSubmitted: 0,
  showResendOptionsPrompt: false,
  currentRetryAttempt: 0,
  simulateRetryFailure: false
}
const mutations = {
  commitForm (state, meta) {
    state.forms.push(meta)
  },
  commitForms (state, meta) {
    state.forms = meta
  },
  commitSubmissionProgress (state, meta) {
    state.submissionProgress = meta
  },
  commitCurrentNumberBeingSubmitted (state, meta) {
    state.currentNumberBeingSubmitted = meta
  },
  commitShowResendOptionsPrompt (state, meta) {
    state.showResendOptionsPrompt = meta
  },
  commitSubmissionComplete (state, meta) {
    state.submissionComplete = meta
  },
  commitSubmissionSuccessful (state, meta) {
    state.submissionSuccessful = meta
  },
  commitPerformingSubmission (state) {
    state.currentRetryAttempt = state.currentRetryAttempt + 1
  },
  commitResetCurrentRetryAttempt (state) {
    state.currentRetryAttempt = 0
  },
  commitSimulateRetryFailure (state, meta) {
    state.simulateRetryFailure = meta
  }
}
const actions = {
  addForm ({ commit }, meta) {
    meta.retry_count = 0
    meta.retry_failure_message = []
    commit('commitForm', meta)
  },
  async submitForms ({ commit, state, getters, rootState }, byPassRetryLimit = false) {
    const sendErrors = []
    const forms = [...state.forms]

    let numberOfForms = getters.numberForms
    if (byPassRetryLimit) {
      numberOfForms = getters.numberInvalidForms
    }

    let currentFormNumber = 0
    commit('commitSubmissionProgress', 0)
    commit('commitCurrentNumberBeingSubmitted', 0)

    if (!byPassRetryLimit) {
      commit('commitPerformingSubmission')
    }

    while (forms.length > 0) {
      const formToSend = forms.pop()
      ++currentFormNumber
      let progress = (currentFormNumber / numberOfForms) * 100
      progress = (progress === 0 ? 100 : progress)

      if (navigator.onLine && (formToSend.retry_count < state.retryLimit || byPassRetryLimit)) {
        commit('commitSubmissionProgress', progress)
        commit('commitCurrentNumberBeingSubmitted', currentFormNumber)
        const method = 'post'
        try {
          if (!state.simulateRetryFailure) {
            let endpoint
            if (formToSend.declinedVaccine === undefined) {
              endpoint = 'addFormResults'
            } else {
              endpoint = 'addVaccineTracking'
            }
            const result = await api.call(method, rootState.apiUrl + endpoint, formToSend)
            if (!result.success) {
              formToSend.retry_failure_message.push(result)
              sendErrors.push(formToSend)
            }
          } else {
            await api.call(method, rootState.apiUrl + 'echo', formToSend)
            if (!byPassRetryLimit) {
              formToSend.retry_failure_message.push('Test failure message')
            }
            sendErrors.push(formToSend)
          }
        } catch (e) {
          if (!byPassRetryLimit) {
            formToSend.retry_failure_message.push(e)
          }
          sendErrors.push(formToSend)
        }
      } else {
        sendErrors.push(formToSend)
      }
    }

    commit('commitSubmissionProgress', 0)
    commit('commitCurrentNumberBeingSubmitted', 0)
    commit('commitSubmissionComplete', true)
    commit('commitSubmissionSuccessful', sendErrors.length === 0)
    await commit('commitForms', [])

    sendErrors.forEach(async sendError => {
      if (sendError.retry_count < state.retryLimit) {
        sendError.retry_count++
      }
      await commit('commitForm', sendError)
    })

    if (!byPassRetryLimit && state.retryLimit === state.currentRetryAttempt) {
      commit('commitResetCurrentRetryAttempt')
    }
  },
  setShowResendOptionsPrompt ({ commit, dispatch }, meta) {
    commit('commitSubmissionComplete', !meta)
    commit('commitSubmissionSuccessful', !meta)
    dispatch('support/setDiagnosticsSent', !meta, { root: true })
    dispatch('support/setDiagnosticSubmissionSuccessful', !meta, { root: true })
    commit('commitShowResendOptionsPrompt', meta)
  },
  resetCurrentRetryAttempt ({ commit }) {
    commit('commitResetCurrentRetryAttempt')
  },
  turnOnSimulatedRetryFailure ({ commit }) {
    commit('commitSimulateRetryFailure', true)
  },
  turnOffSimulatedRetryFailure ({ commit }) {
    commit('commitSimulateRetryFailure', false)
  }
}
const getters = {
  forms: state => state.forms,
  numberForms: state => state.forms.filter(form => form.retry_count < state.retryLimit).length,
  numberInvalidForms: state => state.forms.filter(form => form.retry_count >= state.retryLimit).length,
  submissionProgress: state => state.submissionProgress,
  currentNumberBeingSubmitted: state => state.currentNumberBeingSubmitted,
  showResendOptionsPrompt: state => state.showResendOptionsPrompt,
  submissionComplete: state => state.submissionComplete,
  submissionSuccessful: state => state.submissionSuccessful,
  currentRetryAttempt: state => state.currentRetryAttempt,
  retryLimit: state => state.retryLimit,
  simulateRetryFailure: state => state.simulateRetryFailure
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
